import styled from 'styled-components';

import TabLogoAndSearch from './TabLogoAndSearch';
import TabPersonal from './TabPersonal';
import TabAdmin from './TabAdmin';
import TabSystemStatus from './TabSystemStatus';

const ViewDefault = ({
  props,
  location,
  currentUser,
  rolePermissions,
  isLocationHome,
}) => {
  return (
    <>
      {isLocationHome ? (
        <>
          <Row>
            <Row>
              <TabLogoAndSearch
                {...props}
                location={location}
                currentUser={currentUser}
                isLocationHome={isLocationHome}
              />
              <TabAdmin
                {...props}
                currentUser={currentUser}
                isLocationHome={isLocationHome}
              />
            </Row>
            <TabPersonal
              currentUser={currentUser}
              rolePermissions={rolePermissions}
              isLocationHome={isLocationHome}
            />
          </Row>
          <StatusContainer>
            <TabSystemStatus />
          </StatusContainer>
        </>
      ) : (
        <>
          <Row>
            <TabLogoAndSearch
              {...props}
              location={location}
              currentUser={currentUser}
              isLocationHome={isLocationHome}
            />
            <TabPersonal
              currentUser={currentUser}
              rolePermissions={rolePermissions}
              isLocationHome={isLocationHome}
            />
          </Row>
          <Row>
            <TabAdmin
              {...props}
              currentUser={currentUser}
              isLocationHome={isLocationHome}
            />
            <TabSystemStatus />
          </Row>
        </>
      )}
    </>
  );
};

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
`;

const StatusContainer = styled.div`
  position: absolute;
  right: 5.5rem;
  @media (min-width: 1251px) {
    display: none;
  }
  @media (max-width: 1064px) {
    right: 2.5rem;
  }
`;

export default ViewDefault;
